<template>
  <div>
    <hot-topics :hotTopics="hotTopicsArr" :lectures="lectures" v-if="hotTopicsArr.length"></hot-topics>
    <hot-lectures :appliededHotLecturesArr="appliededHotLecturesArr" v-if="appliededHotLecturesArr.length"></hot-lectures>
    <hot-guests :hotGuests="hotProducers" :title="$store.state.isPastHot === 1 ? '往届优秀出品人' : '优秀出品人'" v-if="hotProducers.length"></hot-guests>
    <hot-guests :hotGuests="hotSpeakers" :title="$store.state.isPastHot === 1 ? '往届明星讲师' : '明星讲师'" v-if="hotSpeakers.length"></hot-guests>
  </div>
</template>
<script>
import hotTopics from './hot-topics'
import hotLectures from './hot-lectures'
import hotGuests from './hot-guests'
export default {
  data () {
    return {}
  },
  components: {
    hotTopics,
    hotLectures,
    hotGuests
  },
  props: [
    'hotTopicsArr',
    'lectures',
    'appliededHotLecturesArr',
    'hotProducers',
    'hotSpeakers'
  ],
  computed: {}
}
</script>
<style scoped lang='sass'>
</style>
